var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operate"},[_c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tabs-container"},_vm._l((_vm.tab.list),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:{active: index === _vm.tab.active},on:{"click":function($event){return _vm.changeTab(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }